import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultLanguage, resources } from './resources';

void i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: 'en',
  defaultNS: 'translation',
  ns: ['translation', 'auth', 'settings', 'mailbox', 'tasks', 'contacts'],
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
  returnEmptyString: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
